import React from "react";

const Footer = () => {
    return (
        <header className="app-footer">
            <h1>© 2024 CUE. All rights reserved.</h1>
        </header>
    );
};

export default Footer;